import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { useMassActions, useNotification } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getListingsMassActionNotificationTitle,
  LISTING_ACTION_RESTORE_MASS,
} from '../../../../RentalPortalListing'
import { performRentalPortalArchiveMassRestore } from '../../RentalPortalArchive.api'
import {
  getIsRentalPortalArchiveActionRestoreMass,
  getRentalPortalArchiveListingItemsCount,
  getRentalPortalArchiveMassActionEligibleItems,
  getRentalPortalArchiveMassActionItems,
  getRentalPortalArchiveMassActions,
  getRentalPortalArchiveMassRestoreDescription,
} from '../../RentalPortalArchive.utils'

import RestoreIcon from '../../../../../icons/restore.svg'

export function useRentalPortalArchiveMassActions({
  allItems,
  excludeIds,
  selectAllPages,
  selected,
  setModal,
  onCleanSelection,
  onClose,
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const {
    getAsyncTaskId,
    handleAddAsyncMassActionNotification,
    handleAddFinishMassActionNotification,
  } = useMassActions({
    getNotificationTitle: getListingsMassActionNotificationTitle,
    onSuccessHandler: onReload,
  })

  const massActionItems = getRentalPortalArchiveMassActionItems({
    allItems,
    excludeIds,
    selectAllPages,
    selected,
  })

  const eligibleItems =
    getRentalPortalArchiveMassActionEligibleItems(massActionItems)

  const massActions = getRentalPortalArchiveMassActions({
    eligibleCount: eligibleItems.length,
    selectedSize: massActionItems.length,
    t,
  })

  function massRestore() {
    return performRentalPortalArchiveMassRestore(eligibleItems)
      .then(({ data }) => {
        onClose()

        const asyncTask = getAsyncTaskId(data)

        if (asyncTask) {
          onCleanSelection()

          handleAddAsyncMassActionNotification({
            action: LISTING_ACTION_RESTORE_MASS,
            task: asyncTask,
            totalCount: getRentalPortalArchiveListingItemsCount(eligibleItems),
          })

          return null
        }

        handleAddFinishMassActionNotification(data, {
          action: LISTING_ACTION_RESTORE_MASS,
          totalCount: data.items.length,
        })

        if (data.success_ids.length === 0) {
          return null
        }

        onCleanSelection()

        return onReload()
      })
      .catch(() => {
        onClose()

        handleAddErrorNotification('RentalPortal.ArchiveRestoreErrorKey')
      })
  }

  function setMassAction(action) {
    if (
      !getIsRentalPortalArchiveActionRestoreMass(action) ||
      eligibleItems.length === 0
    ) {
      return null
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RestoreIcon } },
          submitText: t('RentalPortal.ListingRestoreBtnKey'),
        }}
        description={getRentalPortalArchiveMassRestoreDescription({
          eligibleItems,
          selectedCount: massActionItems.length,
          t,
        })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onClose}
        onSubmit={massRestore}
      />
    )
  }

  return { massActions, setMassAction }
}
